import React, { FC } from 'react';

interface Props {
  style?: any;
  onClick(e): void;
}

const ContentDeleteButton: FC<Props> = (props) => {
  const { children, style, onClick } = props;

  return (
    <button
      className="cmp-contentdeletebutton font-body font-color-gsMiddle"
      style={style}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default ContentDeleteButton;
